module.exports = __webpack_public_path__ + "static/fonts/proximasoftbold-webfont.493157c.woff";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/proximasoftbold-webfont.woff
// module id = 1039
// module chunks = 11